/**
 * Validates that a money value does not contain a decimal point.
 * Handles both string and number inputs (for programmatic usage).
 * Should be called with the original (non-transformed) input value.
 */
export const isWholeNumber = (value: string | number | undefined | null): boolean => {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  if (typeof value === 'number') {
    return Number.isInteger(value);
  }
  const cleaned = String(value).replace(/,/g, '').trim();
  return !cleaned.includes('.');
};

export const MONEY_VALIDATION_MESSAGES = {
  MUST_BE_WHOLE_NUMBER: "Decimals aren't allowed. Please round up or down to a whole number",
} as const;
